import { useState } from "react";
import WorkoutFlow from "@/components/WorkoutFlow";

export default function CompleteSessionButton({ plan, date, onDone }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="complete-session-button"
        onClick={() => setOpen(true)}
        className="bg-volt text-black uppercase tracking-[0.16em] text-xs font-extrabold px-6 py-3.5 hover:bg-white transition-colors"
      >
        Complete session
      </button>
      {open && (
        <WorkoutFlow plan={plan} date={date} onClose={() => setOpen(false)} onDone={onDone} />
      )}
    </>
  );
}
